export const PageStrings = {
  CONTRIBUTE_TRAIL: 'CONTRIBUTE_TRAIL',
  EXPLORE_ALL_PAGE: 'EXPLORE_ALL',
  EXPLORE_FAVORITE_PAGE: 'EXPLORE_FAVORITE',
  EXPLORE_COMPLETED_PAGE: 'EXPLORE_COMPLETED',
  EXPLORE_PENDING_PAGE: 'EXPLORE_PENDING',
  EXPLORE_CUSTOM_PAGE: 'EXPLORE_CUSTOM',
  EXPLORE_TRAIL_MAP_PAGE: 'EXPLORE_TRAIL_MAP',
  EXPLORE_USERS_TRACKS_PAGE: 'EXPLORE_USERS_TRACKS',
  EXPLORE_LIFELINE_PAGE: 'EXPLORE_LIFELINE',
  EXPLORE_USERS_TRACKS_MAP_PAGE: 'EXPLORE_USERS_TRACKS_MAP',
  EXPLORE_USERS_MAPS_PAGE: 'EXPLORE_USERS_MAPS',
  EXPLORE_USERS_MAPS_MAP_PAGE: 'EXPLORE_USERS_MAPS_MAP',
  EXPLORE_COMMUNITY_CONTENT_PAGE: 'EXPLORE_COMMUNITY_CONTENT',
  ET_PHOTO_USER_SLUG: 'alltrails-user',
  SEO_PAGE: 'SEO_PAGE',
  LISTS_PAGE: 'LISTS_PAGE',
  TRAIL_PAGE: 'TRAIL_PAGE',
  HOMEPAGE: 'HOMEPAGE'
};

export const isSingleMapPage = (page: string): boolean =>
  [
    PageStrings.EXPLORE_TRAIL_MAP_PAGE,
    PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE,
    PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE,
    PageStrings.EXPLORE_LIFELINE_PAGE
  ].includes(page);

export const isAtMapPage = (page: string): boolean =>
  [PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE].includes(page);

export const isAtMapCollectionPage = (page: string): boolean =>
  [PageStrings.EXPLORE_USERS_TRACKS_PAGE, PageStrings.EXPLORE_USERS_MAPS_PAGE].includes(page);

export const isListPage = (page: string): boolean =>
  [PageStrings.EXPLORE_FAVORITE_PAGE, PageStrings.EXPLORE_COMPLETED_PAGE, PageStrings.EXPLORE_CUSTOM_PAGE].includes(page);

/**
 * humanizePageName
 * this method converts our page names, CONTRIBUTE_TRAIL to Contribute Trail
 */
export const humanizePageName = (page = ''): string => {
  const frags = page.split('_');
  for (let i = 0; i < frags.length; i += 1) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1).toLowerCase();
  }
  return frags.join(' ');
};
